import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { StackedCard } from './stacked_card';
const EmptyState = () => <BodyText color="muted">
    {I18n.t('publisher.scheduled_events.pending.empty_state')}
  </BodyText>;
const emptyStackCss = "e1qtwug7";
const EmptyStack = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyStackCss, props.className)}>
      <EmptyState />
    </Component>;
});
export const StackedCards = ({
  cards = []
}) => {
  if (isEmpty(cards)) {
    return <EmptyStack />;
  }
  return <div>
      {cards.map(card => <StackedCard key={card.title} card={card} icon={card.icon} />)}
    </div>;
};

require("./stacked_cards.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./stacked_cards.js");